/*
  下部ナビの説明(2026-09-07)
  背景を暗くしてナビだけ残し、変わった点を順に伝える。進み具合は「1/3」で出す。
  ・案内中はナビを縮ませない(見せたいものが縮むと分かりにくいため)
  ・閉じる/最後まで見る/タブを押す のいずれかで終了。以後は出さない
  ・回数と文言はテーマエディターの設定。版(data-version)を変えると全員に出し直す
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-cec-coach]');
  var nav = document.querySelector('[data-cec-bn]');
  if (!root || !nav) return;
  if (window.Shopify && window.Shopify.designMode) return; /* テーマ編集画面では出さない */
  /* PC・タブレット横ではナビ自体を出していないので、案内も動かさない。
     暗幕は body 直下の別要素なので、ここで止めないと暗幕だけが残る */
  if (window.matchMedia && window.matchMedia('(min-width: 1024px)').matches) return;

  /* 置かれている場所によっては、親の重なり順に閉じ込められて
     ページ側の要素(並べ替えバーなど)に隠れる。テーマのドロワーと同じく body 直下へ移す。
     暗幕はナビより下、吹き出しはナビより上に置きたいので、2つの層に分けて出す */
  var veil = root.querySelector('[data-cec-coach-veil]');
  if (root.parentElement !== document.body) document.body.appendChild(root);
  if (veil && veil.parentElement !== document.body) {
    veil.hidden = true;
    document.body.appendChild(veil);
  }

  var steps;
  try {
    steps = JSON.parse(root.querySelector('[data-cec-coach-steps]').textContent);
  } catch (e) {
    return;
  }
  steps = (steps || []).filter(function (s) {
    return s && s.title && (s.target === 'nav' || document.querySelector('[data-cec-action="' + s.target + '"]'));
  });
  if (!steps.length) return;

  if (root.getAttribute('data-audience') === 'customer' && root.getAttribute('data-is-customer') !== 'true') return;

  var KEY = 'cec_nav_coach_' + (root.getAttribute('data-version') || 'v1');
  var MAX = parseInt(root.getAttribute('data-max') || '2', 10) || 2;
  var DELAY = parseInt(root.getAttribute('data-delay') || '0', 10) || 0;

  function load() {
    try {
      return JSON.parse(localStorage.getItem(KEY) || '{}') || {};
    } catch (e) {
      return {};
    }
  }
  function save(v) {
    try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {}
  }

  /* 確認しやすいように、公開中でないテーマ(DRAFT のプレビュー)では毎回出す。
     この時は「見た」記録も残さないので、何度読み込んでも同じ状態から試せる。
     本番(role が main)では今までどおり端末ごとに数回まで。 */
  var themeRole = (window.Shopify && window.Shopify.theme && window.Shopify.theme.role) || '';
  var always = root.getAttribute('data-always') === 'true' || (themeRole !== '' && themeRole !== 'main');

  var state = load();
  if (!always && (state.done || (state.seen || 0) >= MAX)) return;

  var bubble = root.querySelector('.cec-coach__bubble');
  var arrow = root.querySelector('.cec-coach__arrow');
  var elTitle = root.querySelector('[data-cec-coach-title]');
  var elBody = root.querySelector('[data-cec-coach-body]');
  var elCount = root.querySelector('[data-cec-coach-count]');
  var inner = root.querySelector('.cec-coach__inner');
  var elNext = root.querySelector('[data-cec-coach-next]');
  var elBack = root.querySelector('[data-cec-coach-back]');
  var LABEL_NEXT = root.getAttribute('data-label-next') || '次へ';
  var LABEL_DONE = root.getAttribute('data-label-done') || '完了';
  var i = 0;
  var open = false;
  var swapping = false;

  function targetEl() {
    return steps[i].target === 'nav'
      ? nav
      : document.querySelector('[data-cec-action="' + steps[i].target + '"]');
  }

  /* 話題のタブだけを明るく残す。ナビ全体が対象の枚では全部そのまま */
  function spotlight() {
    var tabs = nav.querySelectorAll('.cec-bn__item');
    Array.prototype.forEach.call(tabs, function (el) { el.classList.remove('is-cec-spot'); });
    if (steps[i].target === 'nav') {
      nav.classList.remove('cec-bn--spot');
      return;
    }
    var t = targetEl();
    if (t) t.classList.add('is-cec-spot');
    nav.classList.add('cec-bn--spot');
  }

  function clearSpotlight() {
    nav.classList.remove('cec-bn--spot');
    Array.prototype.forEach.call(nav.querySelectorAll('.cec-bn__item'), function (el) {
      el.classList.remove('is-cec-spot');
    });
  }

  function place() {
    var navRect = nav.getBoundingClientRect();
    var el = targetEl();
    var t = el ? el.getBoundingClientRect() : null;
    if (!t || navRect.height === 0) return;
    var cx = t.left + t.width / 2;
    var w = bubble.offsetWidth;
    var left = Math.min(Math.max(cx - w / 2, 12), window.innerWidth - w - 12);
    bubble.style.left = left + 'px';
    /* 下端を基準にする。上端基準だと、フォント読み込みで文字が折り返して
       吹き出しが縦に伸びた時にナビへ食い込む。
       画面の高さ(innerHeight)は iOS のツールバー開閉でずれるので使わず、
       この層(画面いっぱいに敷いてある)の高さから測る */
    var host = root.getBoundingClientRect();
    bubble.style.bottom = host.height - (navRect.top - host.top) + 12 + 'px';
    arrow.style.left = Math.min(Math.max(cx - left - 6, 14), w - 26) + 'px';
  }

  function render() {
    elTitle.textContent = steps[i].title || '';
    elBody.textContent = steps[i].body || '';
    elCount.textContent = steps.length > 1 ? i + 1 + '/' + steps.length : '';
    elNext.textContent = i < steps.length - 1 ? LABEL_NEXT : LABEL_DONE;
    if (elBack) elBack.hidden = i === 0;
    spotlight();
    place();
  }

  /* 表示直後はナビの位置がまだ動く(プレビューバーの高さ取得・画像の読み込み・
     セーフエリアの確定など)。しばらく見張って、動いたら置き直す */
  function follow(ms) {
    var until = Date.now() + (ms || 2000);
    var last = -1;
    (function tick() {
      if (!open) return;
      var top = nav.getBoundingClientRect().top;
      if (top !== last) {
        last = top;
        place();
      }
      if (Date.now() < until) window.requestAnimationFrame(tick);
    })();
  }

  function show() {
    if (open) return;
    root.hidden = false;
    if (veil) veil.hidden = false;
    document.body.classList.add('cec-coach-on');
    /* 案内中は縮ませない。見せたいものが縮むと伝わらない */
    nav.classList.remove('is-compact', 'is-hidden');
    document.body.classList.remove('cec-bn-compact');
    render();
    /* 表示に切り替えた直後に動かすと iOS で遷移が出ないことがある */
    void bubble.offsetWidth;
    root.classList.add('is-open');
    open = true;
    follow(2500);
  }

  function finish(done) {
    if (!open && root.hidden) return;
    root.classList.remove('is-open', 'is-out', 'is-in', 'is-rev');
    document.body.classList.remove('cec-coach-on');
    clearSpotlight();
    open = false;
    if (!always) {
      var v = load();
      v.seen = (v.seen || 0) + 1;
      if (done) v.done = true;
      save(v);
    }
    window.setTimeout(function () {
      root.hidden = true;
      if (veil) veil.hidden = true;
    }, 340);
    teardown();
  }

  /* 中身は進む向きへ流れる。吹き出しの箱と矢印は CSS の遷移で滑る */
  function step(delta) {
    if (swapping) return;
    swapping = true;
    follow(600);
    if (delta < 0) root.classList.add('is-rev');
    root.classList.add('is-out');
    window.setTimeout(function () {
      i += delta;
      render();
      root.classList.remove('is-out');
      root.classList.add('is-in');
      void inner.offsetWidth;
      root.classList.remove('is-in');
      window.setTimeout(function () { root.classList.remove('is-rev'); }, 180);
      swapping = false;
    }, 170);
  }

  function next() {
    if (i >= steps.length - 1) {
      finish(true);
      return;
    }
    step(1);
  }

  function back() {
    if (i <= 0) return;
    step(-1);
  }

  var onScroll = function () {
    if (!open) return;
    window.requestAnimationFrame(function () {
      nav.classList.remove('is-compact', 'is-hidden');
      place();
    });
  };
  var onTab = function () { finish(true); };

  function teardown() {
    window.removeEventListener('scroll', onScroll);
    window.removeEventListener('resize', onScroll);
    nav.removeEventListener('click', onTab);
  }

  /* 文字の読み込みで高さが変わるので、揃ってからもう一度置き直す */
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { if (open) place(); });
  }

  elNext.addEventListener('click', next);
  if (elBack) elBack.addEventListener('click', back);
  /* 暗幕を押したら次へ。誤って全部見られなくなるのを避ける。終わりたい人は「スキップ」 */
  if (veil) veil.addEventListener('click', next);
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  nav.addEventListener('click', onTab);

  if (DELAY > 0) {
    window.setTimeout(show, DELAY);
  } else {
    show();
  }
})();
